module.exports = __webpack_public_path__ + "static/media/balloons512x384.3ba95750.png";